module.exports = __webpack_public_path__ + "static/media/arsenal_logo.2ba4838e.png";